import { render, staticRenderFns } from "./ResponsiblePagination.vue?vue&type=template&id=0eff02c7&"
import script from "./ResponsiblePagination.vue?vue&type=script&lang=js&"
export * from "./ResponsiblePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports